<template>
  <section>
    <h1>Taxa</h1>
    <ul>
      <li v-for="taxon in TAXA" :key="taxon.comName">
        {{ taxon.comName }}
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["TAXA"])
  }
};
</script>

<style scoped></style>
